var map = {
	"./clothing/items.json": "d429",
	"./kayak/items.json": "7ff3",
	"./lifejacket/items.json": "53b6",
	"./packaging/items.json": "01ff",
	"./safety/items.json": "4d7d",
	"./spraydecks/items.json": "c931",
	"./transport/items.json": "c957"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "faee";